<template>
    <div>
        <div class="crumb-nav">
            <a-breadcrumb>
                <a-breadcrumb-item>
                    <home-outlined />
                </a-breadcrumb-item>
                <template v-for="(item, index) in localNav" :key="index">
                    <a-breadcrumb-item v-if="index > 0 && localNav.length > 2">{{ item.meta.title }}</a-breadcrumb-item>
                </template>
            </a-breadcrumb>
        </div>
        <div class="nav-line"></div>

        <div class="search-box">
            <div :class="formState.year === item.value ? 'year-item active':'year-item'" v-for="item in year_list"
                :key="item" @click="changeYear(item.value)">
                {{ item.label }}
            </div>
        </div>
        <div class="table-content">
            <a-table :row-selection="rowSelection" :dataSource="formState.articleList" :columns="columns"
                rowKey="article_id" row-class-name="article-list" :pagination="pagination" @change="onLoadList">
                <template #bodyCell="{ column, record }">
                    <template v-if="column.dataIndex === 'action'">
                        <span>
                            <a-button type="link" @click="showRes(record.article_id)">查看</a-button>
                            <a-button type="link" @click="editRes(record.article_id)">编辑</a-button>
                            <a-button type="link" @click="downRes(record.article_id)">下载</a-button>
                        </span>
                    </template>
                    <template v-if="column.dataIndex === 'category'">
                        <span>
                            {{ record.category.category_name }}
                        </span>
                    </template>
                    <template v-if="column.dataIndex === 'content_type'">
                        <span v-if="record.content_type == 'video'">
                            视频
                        </span>
                        <span v-else-if="record.content_type == 'image'">
                            图片
                        </span>
                        <span v-else-if="record.content_type == 'article'">
                            文章
                        </span>
                        <span v-else-if="record.content_type == 'audio'">
                            音频
                        </span>
                    </template>
                </template>
                <template #title v-if="query_dept_id == adminUserInfo.dept_id || adminUserInfo.dept_id == 0">
                    <a-space>
                        <a-button type="primary" @click="addRes()">上传</a-button>
                        <!-- <a-button type="primary" :disabled="checkRow.length == 0" @click="shareRes()">分享</a-button> -->
                    </a-space>
                </template>
            </a-table>
        </div>

        <a-modal v-model:visible="shareVisible" centered title="选择被共享人" @ok="handleShare">
            <a-table :row-selection="rowSelectionShare" :dataSource="checkRow.share_user" :columns="shareColumns"
                rowKey="admin_user_id" :pagination="false">
                <template #bodyCell="{ column,record }">
                    <template v-if="column.dataIndex === 'show_action'">
                        <span>
                            <a-checkbox v-model:checked="record.show_action">查看
                            </a-checkbox>
                        </span>
                    </template>
                    <template v-if="column.dataIndex === 'edit_action'">
                        <span>
                            <a-checkbox v-model:checked="record.edit_action">编辑
                            </a-checkbox>
                        </span>
                    </template>
                    <template v-if="column.dataIndex === 'down_action'">
                        <span>
                            <a-checkbox v-model:checked="record.down_action">下载
                            </a-checkbox>
                        </span>
                    </template>
                </template>
            </a-table>
        </a-modal>

        <a-modal v-model:visible="downVisible" width="800px" centered title="下载" @ok="handleDownOk" :footer="null">
            <a-row v-for="(item,index) in downFiles" :key="index" style="margin: 10px 0;">
                <a-col :span="20">
                    <a-image :width="100" v-if="contentType == 'image'" :src="item.url + '?x-oss-process=style/stylethumb'" />
                    {{ item.info }}
                </a-col>
                <a-col :span="4" style="text-align: right;">
                    <a-button type="link" @click="downOneFile(index)">下载</a-button>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import {
        defineComponent,
        ref,
        reactive,
        computed,
        onMounted,
        watch
    } from "vue";
    import * as Api from "@/views/resource/api";

    import {
        HomeOutlined
    } from "@ant-design/icons-vue";

    import {
        useRoute,
        useRouter
    } from "vue-router";
    import {
        message
    } from "ant-design-vue";

    import OSS from 'ali-oss';

    export default defineComponent({
        name: "CsLinks",
        components: {
            HomeOutlined
        },
        props: {
            contentType: {
                type: String,
                default: ""
            },
        },
        emits: [],
        setup(props) {
            const router = useRouter();
            const route = useRoute();

            const query_dept_id = ref(parseInt(route.query.dept_id ? route.query.dept_id : 0));

            const adminUserInfo = reactive({
                dept_id: 0,
                user_name: '',
                real_name: ''
            });
            const getAdminUserInfo = () => {
                Api.api_admin_user_info().then((res) => {
                    if (res.status == 200) {
                        console.log(res)
                        adminUserInfo.dept_id = res.data.dept_id;
                        adminUserInfo.user_name = res.data.user_name;
                        adminUserInfo.real_name = res.data.real_name;
                    }
                });
            }

            watch(
                () => route.query.dept_id,
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        query_dept_id.value = newVal;
                        onLoadList();
                    }
                }
            )



            const formState = reactive({
                category_id: 1,
                keyword: "",
                betweenTime: [],
                page: 1,
                articleList: [],

                total: 0,
                current_page: 0,
                per_page: 0,
                year: ""
            });

            // console.log(formState)

            const year_list = ref([]);

            const changeYear = (index) => {
                formState.year = index;
                onLoadList();
            }

            // 列表分页数据
            const pagination = computed(() => ({
                total: formState.total,
                current: formState.current_page,
                pageSize: formState.per_page,
            }));

            // 根据条件获取列表数据
            const onLoadList = (page, filters, sorter) => {
                if (query_dept_id.value > 0) {
                    Api.getArticleList({
                        page: page ? page.current : 1,
                        limit: page ? page.pageSize : 10,
                        category_id: formState.category_id,
                        dept_id: query_dept_id.value,
                        keyword: formState.keyword,
                        year: formState.year,
                        content_type: props.contentType,
                        betweenTime: formState.betweenTime,
                        sorter: sorter ? sorter : false,
                    }).then((res) => {
                        formState.articleList = res.data.data;
                        formState.total = res.data.total;
                        formState.per_page = res.data.per_page;
                        formState.current_page = res.data.current_page;
                    });
                }
            };



            // 初始化
            onMounted(() => {
                // 获取年限
                Api.year_list().then((res) => {
                    if (res.status == 200) {
                        year_list.value = res.data;
                        if (res.data.length > 0) {
                            formState.year = res.data[0].value;
                            onLoadList();
                        }
                    }
                });

                Api.share_user_list().then((res) => {
                    if (res.status == 200) {
                        checkRow.share_user = res.data.list;
                    }
                });
                getAdminUserInfo();
                getStsToken();
            });

            // 查看资料
            const showRes = (article_id) => {
                checkAuthRes(article_id, '/resource/show', {
                    id: article_id
                });
            }

            // 上传资料
            const addRes = () => {
                router.push({
                    path: "/resource/add",
                    query: {
                        dept_id: query_dept_id.value
                    },
                });
            }

            // 编辑资料
            const editRes = (article_id) => {
                checkAuthRes(article_id, '/resource/edit', {
                    id: article_id
                });
            }

            const downVisible = ref(false);

            const downFiles = ref([]);

            const handleDownOk = () => {
                downVisible.value = false;
            }

            const downOneFile = (index) => {
                downFile(downFiles.value[index]['info'], index);
            }
            // 下载资料
            const downRes = (article_id) => {
                checkAuthRes(article_id, '/resource/down', {
                    id: article_id
                });
            }

            //检查权限
            const checkAuthRes = (article_id, path, params) => {
                Api.check_user_auth({
                    article_id: article_id
                }).then((res) => {
                    if (res.status === 200) {
                        if (path == '/resource/show') {
                            if (res.data.show_action == 1) {
                                router.push({
                                    path: path,
                                    query: params,
                                });
                            } else {
                                message.error('没有权限');
                            }
                        }

                        if (path == '/resource/edit') {
                            if (res.data.edit_action == 1) {
                                router.push({
                                    path: path,
                                    query: params,
                                });
                            } else {
                                message.error('没有权限');
                            }
                        }

                        if (path == '/resource/down') {
                            if (res.data.down_action == 1) {
                                // 这里执行下载操作
                                Api.getArticleDetail({
                                    article_id: article_id
                                }).then((res) => {
                                    if (res.status == 200) {
                                        if (res.data.extra_files.length > 0) {
                                            downVisible.value = true;
                                            // console.log(res.data.extra_files)
                                            downFiles.value = res.data.extra_files;
                                        }
                                    }
                                });
                            } else {
                                message.error('没有权限');
                            }
                        }
                    } else {
                        message.error(res.message);
                    }
                });
            }

            const downFile = (file_path, index) => {
                const client = new OSS({
                    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                    region: "oss-cn-chengdu",
                    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                    accessKeyId: upStsData.accessKeyId,
                    accessKeySecret: upStsData.accessKeySecret,
                    // 从STS服务获取的安全令牌（SecurityToken）。
                    stsToken: upStsData.SecurityToken,
                    // 填写Bucket名称，例如examplebucket。
                    refreshSTSToken: async () => {
                        // 向您搭建的STS服务获取临时访问凭证。
                        getStsToken;
                        return {
                            accessKeyId: upStsData.accessKeyId,
                            accessKeySecret: upStsData.accessKeySecret,
                            stsToken: upStsData.SecurityToken
                        }
                    },
                    // 刷新临时访问凭证的时间间隔，单位为毫秒。
                    refreshSTSTokenInterval: 300000,
                    bucket: "abzwhg-resource",
                });

                // 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
                const filename = file_path
                const response = {
                    'content-disposition': `attachment; filename=${encodeURIComponent(filename)}`
                }
                // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
                const url = client.signatureUrl(file_path, {
                    response
                });
                console.log(url);
                console.log(index)

                // 创建标签。
                const link = document.createElement('a')
                // 将标签绑定href属性。
                link.href = url
                // 指定下载后的本地文件名称。
                link.download = file_path
                // 下载Object。
                link.click()
                // 移除绑定的URL。
                window.URL.revokeObjectURL(link.href)


                // client.get(file_path, {
                //     headers: {},
                // }).then(r => {
                //     console.log(r)
                //     console.log(index)
                //     // 将返回的数据通过Blob的形式转为可下载的Object。
                //     const newBlob = new Blob([r.content], {
                //         type: r.res.headers['content-type']
                //     });
                //     // 创建标签。
                //     const link = document.createElement('a')
                //     // 将标签绑定href属性。
                //     link.href = window.URL.createObjectURL(newBlob)
                //     // 指定下载后的本地文件名称。
                //     link.download = file_path
                //     // 下载Object。
                //     link.click()
                //     // 移除绑定的URL。
                //     window.URL.revokeObjectURL(link.href)
                // })
            }

            // 分享资料
            const shareVisible = ref(false);

            const shareActions = ref([]);
            const handleShare = () => {
                Api.share_user_done({
                    docs: checkRow.docs_list,
                    users: checkRow.share_user
                }).then((res) => {
                    if (res.status === 200) {
                        message.success(res.message);
                        shareVisible.value = false;
                    } else {
                        message.error(res.message);
                    }
                });
            }

            const shareRes = () => {

                // 获取系统用户
                shareVisible.value = true;
            }

            const checkRow = reactive({
                docs_list: [],
                share_user: [],
            });

            const rowSelection = {
                onChange: (selectedRowKeys, selectedRows) => {
                    checkRow.docs_list = selectedRowKeys;
                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                }
            };

            const rowSelectionShare = {
                onChange: (selectedRowKeys, selectedRows) => {
                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                }
            };

            const upStsData = reactive({
                accessKeyId: '',
                accessKeySecret: '',
                SecurityToken: '',
            });

            const getStsToken = () => {
                Api.getStsToken().then((res) => {
                    if (res.status == 200) {
                        console.log(res)
                        upStsData.accessKeyId = res.data.AccessKeyId;
                        upStsData.accessKeySecret = res.data.accessKeySecret;
                        upStsData.SecurityToken = res.data.SecurityToken;
                    }
                });
            }

            const localNav = computed(() => {
                return route.matched;
            });

            return {
                year_list,
                changeYear,
                formState,
                pagination,
                onLoadList,
                showRes,
                shareActions,
                addRes,
                editRes,
                downRes,
                shareRes,
                downVisible,
                downFiles,
                downOneFile,
                handleDownOk,
                checkRow,
                shareVisible,
                handleShare,
                rowSelection,
                rowSelectionShare,
                adminUserInfo,
                query_dept_id,
                localNav,
                columns: [{
                        title: '序号',
                        dataIndex: 'article_id',
                        key: 'article_id',
                    },
                    {
                        title: '项目名称',
                        dataIndex: 'title',
                        key: 'title',
                    },
                    {
                        title: '年代',
                        dataIndex: 'year',
                        key: 'year',
                    },
                    {
                        title: '资源形式',
                        dataIndex: 'content_type',
                        key: 'content_type',
                    },
                    {
                        title: '作者',
                        dataIndex: 'author',
                        key: 'author',
                    },
                    // {
                    //     title: '分类',
                    //     dataIndex: 'category',
                    //     key: 'category',
                    // },
                    {
                        title: "操作",
                        dataIndex: "action",
                        key: "action",
                    },
                ],
                shareColumns: [{
                        title: '序号',
                        dataIndex: 'admin_user_id',
                        key: 'admin_user_id',
                    },
                    {
                        title: '成员',
                        dataIndex: 'real_name',
                        key: 'real_name',
                    },
                    {
                        title: "查看",
                        dataIndex: "show_action",
                        key: "show_action",
                    },
                    {
                        title: "编辑",
                        dataIndex: "edit_action",
                        key: "edit_action",
                    },
                    {
                        title: "下载",
                        dataIndex: "down_action",
                        key: "down_action",
                    },
                ],
                plainOptions: ['查看', '编辑', '下载']
            };
        },
    });
</script>
<style lang="less" scoped>
    .crumb-nav {
        display: flex;
        justify-content: space-between;
    }

    .nav-line {
        width: 100%;
        height: 6px;
        background: url('~@/assets/img/s5.png') repeat-x;
        margin: 20px 0;
    }

    .form-box {
        padding-top: 20px;
    }

    .search-box {
        flex-wrap: wrap;

        .year-item {
            cursor: pointer;
            display: inline-block;
            width: 100px;
            margin-right: 10px;
            margin-bottom: 10px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            background: url('~@/assets/img/year.png') no-repeat center;
        }

        .year-item:hover {
            color: #fff;
            background: url('~@/assets/img/year_active.png') no-repeat center;
        }

        .active {
            color: #fff;
            background: url('~@/assets/img/year_active.png') no-repeat center;
        }
    }

    .table-content {
        margin-top: 20px;
    }
</style>